import type { ReactNode } from 'react';

function renderResultsBold(chunks: ReactNode): ReactNode {
  return <strong>{chunks}</strong>;
}

export const SERVICE_PRICE_RESULTS_RICH_TEXT_FORMATTERS = {
  b: renderResultsBold,
};
